// รวม aggregate รายจ่าย แยกเงินออมที่ผู้ใช้ระบุจากเงินสดคงเหลือ และคืนสัดส่วนทุกหมวดด้วยยอดหลังจัดสรรเป็นตัวหารเดียวกัน
export const calculateExpenseSummary = (balanceData) => {
  const fixedExpense = Number(balanceData?.sum_expenses_fixed || 0);
  const variableExpense = Number(balanceData?.sum_expenses_variable || 0);
  const storedSavingExpense = Number(
    balanceData?.sum_expenses_invest_saving || 0
  );
  const storedResidualAllocation = Math.max(
    Number(balanceData?.temp_net_cash_flow || 0),
    0
  );
  const explicitSavingExpense = Math.max(
    storedSavingExpense - storedResidualAllocation,
    0
  );
  const annualIncome = Number(balanceData?.salary_propotion || 0);
  const expenseBeforeAllocation =
    fixedExpense + variableExpense + explicitSavingExpense;
  const positiveResidualAllocation = Math.max(
    annualIncome - expenseBeforeAllocation,
    0
  );
  const savingAndInvestmentExpense =
    explicitSavingExpense + positiveResidualAllocation;
  const expenseIncludingAllocation =
    expenseBeforeAllocation + positiveResidualAllocation;
  const expensePercentages =
    expenseIncludingAllocation > 0
      ? {
          fixed: (fixedExpense / expenseIncludingAllocation) * 100,
          variable: (variableExpense / expenseIncludingAllocation) * 100,
          savingAndInvestment:
            (savingAndInvestmentExpense / expenseIncludingAllocation) * 100,
        }
      : {
          fixed: 0,
          variable: 0,
          savingAndInvestment: 0,
        };

  return {
    fixedExpense,
    variableExpense,
    explicitSavingExpense,
    positiveResidualAllocation,
    expenseBeforeAllocation,
    savingAndInvestmentExpense,
    expenseIncludingAllocation,
    expensePercentages,
  };
};
